import { AxiosResponse } from 'axios';

import { TaxIdKeys, isTaxIdKey } from 'apis/financial-data-registry/types';

import { buildErrorTypeGuard } from './utils';

export class TaxInfoFormatValidationError extends Error {
  invalidValues: TaxIdKeys;

  constructor(invalidValues: TaxIdKeys) {
    const message = invalidValues.map(value => `Invalid ${value} format`).join(', ');

    super(message);
    this.invalidValues = invalidValues;
    this.message = message;
    this.name = 'TaxInfoFormatValidationError';
  }
}

type TaxInfoValidationErrorData = {
  error: string;
  message: string;
  taxIdKeys: TaxIdKeys;
};

const taxInfoValidationErrorResponseValidator = (response: AxiosResponse) => {
  return (
    response.status === 422 && response.data.error === 'validation_error' && response.data.taxIdKeys.every(isTaxIdKey)
  );
};

export const isTaxInfoValidationError = buildErrorTypeGuard<TaxInfoValidationErrorData>(
  taxInfoValidationErrorResponseValidator,
);

export type ValidationError = {
  reason: string;
  value: string;
};

type KybSubmissionValidationErrorData = {
  validationErrors: ValidationError[];
};

const kybSubmissionValidationErrorResponseValidator = (response: AxiosResponse) => {
  return response.status === 422 && typeof response.data?.validationErrors === 'object';
};

export const isKybSubmissionValidationError = buildErrorTypeGuard<KybSubmissionValidationErrorData>(
  kybSubmissionValidationErrorResponseValidator,
);

type KybSubmissionInvalidStateErrorData = {
  message: string;
  state: string;
};

const kybSubmissionInvalidStateErrorResponseValidator = (response: AxiosResponse) => {
  return response.status === 422 && response.data?.state && response.data?.message;
};

export const isKybSubmissionInvalidStateError = buildErrorTypeGuard<KybSubmissionInvalidStateErrorData>(
  kybSubmissionInvalidStateErrorResponseValidator,
);
